export default class MessagesListPageController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;
        this.translate = this.injector.get('$translate');

        this._initStore();
    }

    _initStore() {
        this.store = this.injector.get('Messages').reset({
            persist: true,
            listname: 'SentEmailsListview'
        });
        this.store.commit('setVm', this);
        // this.store.commit('setPermanentFilters', {
        //     type: 'email'
        // });
        this.store.commit('setTitle', this.translate.instant(`messages.controllers.pages.list.title`))
        this.store.dispatch('loadWorkflows', 'messages::list');
    }
}

MessagesListPageController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/messages/controllers/pages/list.js